import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

// custom components
import { CustomSidebar, CustomNavbar } from '../components/atoms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// utils

// scenes
import Home from '../scenes/home/index';
import Introduction from '../scenes/introduction/index';
import CreateBooking from '../scenes/create-booking/index'
import GettingBookings from '../scenes/getting-bookings/index'
import GettingABooking from '../scenes/getting-a-booking/index'
import PrivacyPolicy from '../scenes/other/privacy-policy';
import GettingStarted from '../scenes/getting-started/index';
import UpdateBooking from '../scenes/update-booking/index';
import DeleteBooking from '../scenes/delete-booking/index';
import Authentication from '../scenes/authentication/index';

// login box
import { Login } from '../components/organisms'

// responsive page
import { useMediaQuery } from 'react-responsive'

const PageTemplate = (props) => {

    const border = false;

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    return (
        <>
        <Container>
        <Row>

            <CustomNavbar />

            {
                !isTabletOrMobile &&
                <Col xs={2} style={{ borderStyle: border && 'solid', borderWidth: border && 1}}>
                    <CustomSidebar />
                </Col>
            }

            <Col style={{ borderStyle: border && 'solid', borderWidth: border && 1}}>
                {props.children}
            </Col>

        </Row>
        </Container>
        </>
    )
}

const AppRouter = () => {
    return (
        <Router>
            <Routes>
                <Route path='/' element={
                    <PageTemplate><Home /></PageTemplate>
                } />

                <Route path='/introduction' element={
                    <PageTemplate><Introduction /></PageTemplate>
                } />

                <Route path='/getting-started' element={
                    <PageTemplate><GettingStarted /></PageTemplate>
                } />

                <Route path='/login' element={
                    <PageTemplate><Login /></PageTemplate>
                } />

                <Route path='/*' element={
                    <PageTemplate>
                        <Login />
                    </PageTemplate>
                } />

            </Routes>
        </Router>
    )

}

export default AppRouter;
